<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container d-flex flex-column">
        <header class="mdc-top-app-bar position-static">
          <div class="mdc-top-app-bar__row">
            <section
              class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start"
            >
              <!-- <a class="material-icons mdc-top-app-bar__navigation-icon" @click="moveSurveyView()">close</a> -->
              <a
                class="material-icons mdc-top-app-bar__navigation-icon"
                @click="goBackToSurvey"
                >close</a
              >
            </section>

            <section class="mdc-top-app-bar__section title">
              <div class="mdc-top-app-bar__title">
                {{ $t("735") }}
                <!-- {{setTitle}} -->
                <!-- 설문 피드백 -->
              </div>
            </section>

            <section
              class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end"
            >
              <a
                class="material-icons mdc-top-app-bar__action-item"
                aria-label="search"
                alt="search"
              ></a>
            </section>
          </div>
        </header>
        <!-- {{questions}}
                {{currentQuestionIndex}} -->
        <section class="flex-grow-1 scroll-y pdl-18 pdr-16 pdt-16">
          <transition name="slide">
            <component
              v-if="questions[currentQuestionIndex]"
              ref="questionComp"
              :is="questions[currentQuestionIndex].type.value"
              :question="questions[currentQuestionIndex]"
              :eachViewFeedback="eachViewFeedback"
              :key="questions[currentQuestionIndex].id"
              :sortHighestNum="sortHighestNum"
              @switchSortValue="switchSortValue"
              @sort="choiceSort"
            >
            </component>
          </transition>
        </section>

        <section>
          <hr class="divider" />
          <div
            class="d-flex flex-row justify-content-between align-items-center pdt-10 pdb-44 pdl-10 pdr-10"
          >
            <button
              class="mdc-button btn-white"
              @click="prevQuestion()"
              v-if="!isFirstQuestion"
              :disabled="isFirstQuestion"
            >
              <i class="material-icons mdc-button__icon">keyboard_arrow_left</i>
              {{ $t("711") }}
            </button>
            <div></div>

            <button
              class="mdc-button btn-white"
              @click="nextQuestion()"
              v-if="!isLastQuestion"
            >
              {{ $t("712") }}
              <!-- 다음문항 -->
              <i class="material-icons mdc-button__icon"
                >keyboard_arrow_right</i
              >
            </button>

            <button
              class="mdc-button mdc-button--raised btn-red"
              @click="moveSurveyView()"
              v-if="isLastQuestion"
            >
              {{ $t("745") }}
              <!-- 완료 -->
            </button>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 설문 피드백 메인 컴포넌트(survey feedback main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import surveyApi from "@/api/surveyApi.js";
import { surveyMixin } from "@/mixins/survey.js";

export default {
  name: "surveyFeedback",
  components: {
    SHORT_ANSWER: () => import("./question/ShortAnswerFeedback.vue"),
    CHOICE_SINGLE: () => import("./question/ChoiceSingleFeedback.vue"),
    CHOICE_MULTIPLE: () => import("./question/ChoiceMultipleFeedback.vue"),
    STARS: () => import("./question/StarsFeedback.vue"),
    RANKING: () => import("./question/RankingFeedback.vue"),
  },
  mixins: [surveyMixin],
  // mixins: [examMixin],
  mounted() {},

  data() {
    return {
      questions: [],
      currentQuestionIndex: 0,
      //currentQuestionIndex: 4,
      eachViewFeedback: false,
      sortHighestNum: false
    };
  },

  created() {
    this.fatchData();
  },

  computed: {
    // is first question
    isFirstQuestion() {
      return this.currentQuestionIndex === 0 ? true : false;
    },

    // is last question
    isLastQuestion() {
      return this.currentQuestionIndex === this.questions.length - 1
        ? true
        : false;
    },
  },

  methods: {
    fatchData() {
      this.sortHighestNum = true;
      let params = {
        respondentId: this.$route.params.respondentId,
        distId: this.$route.params.distId,
      };

      // get survey respondent feedback
      surveyApi.surveyRespondentFeedback(params).then((response) => {
        this.feedbackData = response.data.data;

        this.eachViewFeedback = this.feedbackData.eachViewFeedback;
        let number = 1;

        // set question list
        _.each(this.feedbackData.groups, (group, groupIndex) => {
          _.each(group.questions, (question, questionIndex) => {
            question.essential = group.essential;
            question.number = number++;

            this.questions.push(question);
          });
        });
      });
    },

    // move next question
    nextQuestion() {
      this.currentQuestionIndex++;
    },

    // move prev question
    prevQuestion() {
      this.currentQuestionIndex--;
    },

    choiceSort() {
      const currentObject = this.questions[this.currentQuestionIndex];
      if(currentObject.choices.length > 0) {
        currentObject.choices.sort(this.sortCompare());
      } else if(currentObject.stars != null) {
        currentObject.stars.ratios.sort(this.starCompare());
      }
    },

    sortCompare() {
        return (a, b) =>
        this.sortHighestNum
        ? a.selectionRatio - b.selectionRatio
        : b.selectionRatio - a.selectionRatio;
    },

    starCompare() {
        return (a, b) =>
        this.sortHighestNum
        ? a.view - b.view
        : b.ratio - a.ratio;
    },

    switchSortValue(sortHighestNum) {
      this.sortHighestNum = !sortHighestNum;
    },

    goBackToSurvey() {
      if (this.$route.query.distributionType == "SATISFACTION") {
        this.$router.push(
          "/learn/" +
            this.$route.query.learnId +
            "?status=" +
            this.$route.query.status +
            "&tab=viewSurvey"
        );
      } else {
        this.$router.push({
          name: "IndependentSurveyTotalView",
          params: { distId: this.$route.params.distId },
          query: this.$route.query,
        });
      }
    },
  },
};
</script>
